export default __webpack_public_path__ + "static/media/house-block.0358c6db.jpg";